export const wrap = <T>(data: T): Array<T> => {
  if (Array.isArray(data)) {
    return data;
  }

  return [data];
};
